import { useSearchParams } from "next/navigation";
import { useState } from "react";
import BaseModule from "@/components/site-builder/BaseModule";
import { createIFrameURL } from "@/components/site-builder/modules/IframeModule/utils/createIFrameURL";
import { useDetectDevice } from "@/hooks/useDetectDevice";
import FullscreenContent from "../../../common/FullscreenContent";
import { type IframeModuleType } from "./types";

export interface IframeModuleProps {
  module: IframeModuleType;
}

export default function IframeModule(props: IframeModuleProps) {
  const { module } = props;
  const {
    id,
    body: {
      url,
      appendIncomingQueryParametersToUrl,
      height,
      heightMobile,
      showMaximiseScreenOption,
    },
  } = module;
  const searchParams = useSearchParams();
  const { isMobile } = useDetectDevice();
  const [isFullScreen, setIsFullScreen] = useState(false);

  const iframeUrl = appendIncomingQueryParametersToUrl
    ? createIFrameURL(url, searchParams)
    : url;
  const iframeHeight = isMobile ? heightMobile : height;
  const fullHeight = isFullScreen && !isMobile;

  const content = (
    <iframe
      src={iframeUrl}
      id={id}
      width="100%"
      height={fullHeight ? "100%" : iframeHeight}
    />
  );

  return (
    <BaseModule module={module}>
      {showMaximiseScreenOption ? (
        <FullscreenContent onChange={(state) => setIsFullScreen(state)}>
          {content}
        </FullscreenContent>
      ) : (
        content
      )}
    </BaseModule>
  );
}
